import { gql } from "@apollo/client";

const SLOT_FIELDS = `
  id
  clientId
  clientName
  slotNumber
  label
  assignedEmail
  isActive
  members { empId empName role addedAt addedBy { empid name } }
  legacyAssignedAssociate
  legacyBackUpAssociate
  legacyServicesAssigned
  department
  createdAt
  createdBy { empid name }
  deactivatedAt
  deactivatedBy { empid name }
`;

export const GET_SLOTS_BY_CLIENT = gql`
  query GetSlotsByClient($clientId: String!) {
    getSlotsByClient(clientId: $clientId) {
      status message totalCount
      records { ${SLOT_FIELDS} }
    }
  }
`;

export const GET_SLOTS_BY_EMPLOYEE = gql`
  query GetSlotsByEmployee($employeeId: String!) {
    getSlotsByEmployee(employeeId: $employeeId) {
      status message totalCount
      records { ${SLOT_FIELDS} }
    }
  }
`;

export const GET_ALL_SLOTS = gql`
  query GetAllSlots(
    $search: String, $isActive: Boolean,
    $clientId: String, $employeeId: String,
    $hasEmail: Boolean, $hasMembers: Boolean,
    $limit: Int
  ) {
    getAllSlots(
      search: $search, isActive: $isActive,
      clientId: $clientId, employeeId: $employeeId,
      hasEmail: $hasEmail, hasMembers: $hasMembers,
      limit: $limit
    ) {
      status message totalCount
      records { ${SLOT_FIELDS} }
    }
  }
`;

export const GET_ACCESS_HEALTH_SUMMARY = gql`
  query GetAccessHealthSummary {
    getAccessHealthSummary {
      status message
      activeClientsWithoutSlots
      slotsWithoutEmail
      slotsWithoutMembers
      activeEmployeesWithoutSlots
      sampleClientsWithoutSlots
      sampleSlotsWithoutEmail
      sampleSlotsWithoutMembers
      sampleEmployeesWithoutSlots
    }
  }
`;

export const ADD_SLOT = gql`
  mutation AddSlot($input: CreateSlotInput!) {
    addSlot(input: $input) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const UPDATE_SLOT = gql`
  mutation UpdateSlot($slotId: String!, $input: UpdateSlotInput!) {
    updateSlot(slotId: $slotId, input: $input) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const ADD_SLOT_MEMBER = gql`
  mutation AddSlotMember($slotId: String!, $member: SlotMemberInput!, $actorEmpid: String, $actorName: String) {
    addSlotMember(slotId: $slotId, member: $member, actorEmpid: $actorEmpid, actorName: $actorName) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const REMOVE_SLOT_MEMBER = gql`
  mutation RemoveSlotMember($slotId: String!, $empId: String!) {
    removeSlotMember(slotId: $slotId, empId: $empId) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const SET_SLOT_MEMBER_ROLE = gql`
  mutation SetSlotMemberRole($slotId: String!, $empId: String!, $role: String!) {
    setSlotMemberRole(slotId: $slotId, empId: $empId, role: $role) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const DEACTIVATE_SLOT = gql`
  mutation DeactivateSlot($slotId: String!, $actorEmpid: String, $actorName: String) {
    deactivateSlot(slotId: $slotId, actorEmpid: $actorEmpid, actorName: $actorName) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const REACTIVATE_SLOT = gql`
  mutation ReactivateSlot($slotId: String!) {
    reactivateSlot(slotId: $slotId) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;

export const DELETE_SLOT = gql`
  mutation DeleteSlot($slotId: String!) {
    deleteSlot(slotId: $slotId) {
      status message
      record { ${SLOT_FIELDS} }
    }
  }
`;
